module.exports = new __parcel__URL__("mmnumberkeyboard.03c445b6.webp").toString();